import { render, staticRenderFns } from "./BaseDateInput.vue?vue&type=template&id=85cbd60c&scoped=true&"
import script from "./BaseDateInput.vue?vue&type=script&lang=ts&"
export * from "./BaseDateInput.vue?vue&type=script&lang=ts&"
import style0 from "./BaseDateInput.vue?vue&type=style&index=0&id=85cbd60c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cbd60c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
